{
  "name": "defense-game",
  "version": "1.1.0",
  "scripts": {
    "serve": "parcel src/index.html --open",
    "build": "parcel build src/index.html --no-scope-hoist"
  },
  "author": "Pavel (Paul) Popov <justredpaul@ya.ru>",
  "private": true,
  "devDependencies": {
    "@babel/plugin-proposal-class-properties": "^7.13.0",
    "@parcel/transformer-image": "^2.0.0-beta.2",
    "@parcel/transformer-sass": "^2.0.0-beta.2",
    "parcel": "^2.0.0-beta.2",
    "parcel-reporter-static-files-copy": "^1.3.0",
    "serve-static": "^1.14.1",
    "sharp": "^0.28.1"
  },
  "alias": {
    "helpers": "./src/helpers",
    "baseClasses": "./src/baseClasses"
  },
  "dependencies": {
    "nanoid": "^3.1.23"
  }
}
